import fr from 'facet-rest';
import RTEWithLabel from '../Components/UI/Overrides/RTEWithLabel';

const hiddenFieldNames = ['timeHorizonType', 'timeHorizonValue'];
// eslint-disable-next-line import/prefer-default-export
export const QuestionnaireGoalOverride = fr.metaOverride()
  .nameOverride(hiddenFieldNames, { hidden: true })
  .nameOverride('endDate', {
    _customProps: {
      openTo: 'year',
    },
  })
  .nameOverride('description', {
    _component: () => RTEWithLabel,
    _customProps: {
      size: 'sm',
      label: 'Description',
    },
  });
